import {
	transformComponentsToLink,
	transformNewsArticlesToCards,
	transformNewsArticleToFeature,
} from '@/helpers/transforms'
import type { LatestVenueNewsBlock } from '@/payload-types'
import type { SerializedBlockNode } from '@payloadcms/richtext-lexical'
import type { JSXConverter } from '@payloadcms/richtext-lexical/react'
import { CardListBlock } from '../blocks/CardListBlock'

export const LatestVenueNewsConverter: JSXConverter<SerializedBlockNode<LatestVenueNewsBlock>> = ({
	node,
}) => {
	const { articles, layout, viewAllButtonText, viewAllButtonHref } = node.fields
	if (!articles || articles.length === 0) return null

	const button = transformComponentsToLink(viewAllButtonText, viewAllButtonHref)

	if (layout === 'with-featured-article') {
		const [feature, ...cards] = articles
		return (
			<CardListBlock
				featuredCard={transformNewsArticleToFeature(feature)}
				cards={transformNewsArticlesToCards(cards)}
				button={button}
			/>
		)
	}

	const cards = transformNewsArticlesToCards(articles)
	return <CardListBlock cards={cards} button={button} />
}
